import { Injectable } from '@angular/core';
import { ServiceService } from './service.service';

interface IMfaQrCreateResult {
  resultado: boolean,
  log: string,
  extras:[{
    qr: string,
    manual: string,
  }]
}

export interface IAprobacionIniciada {
  aprobacion_id: number;   // int generado por la secuencia PostgreSQL
  token_sesion: string;
  expira_en: number;
}

export interface IAprobacionEstado {
  estado: 'pendiente' | 'aprobado' | 'rechazado' | 'expirado';
}

interface MFAActivaResult {
  resultado: boolean,
  log: string,
  extras:[]
}

interface MFAValidarResult {
  resultado: boolean,
  log: string,
  extras:[]
}

var httpOptions = {

  headers: { 'Content-Type': 'application/json' ,"token":""}

};

@Injectable({
  providedIn: 'root'
})
export class MfaService extends ServiceService {

    generateMFAQr (): Promise<IMfaQrCreateResult> {
      return new Promise((resolve,rejects)=>{
        httpOptions.headers.token=localStorage.getItem("token");
        this.get<IMfaQrCreateResult>("api/mfa/crearqr", httpOptions)
          .subscribe((data) => {
            if (data.resultado != undefined  && (data.resultado !==0 || data.resultado !==false)){
              resolve(data.extras[0]);
            }
            else{
              rejects(false);
            }
          }) ;
      });
    }

    activarMFA(code: string): Promise<boolean> {
      console.log(code);
      return new Promise((resolve,rejects)=>{
        httpOptions.headers.token=localStorage.getItem("token");
        let postParams =  ({ code: code });

        this.post<MFAActivaResult>("api/mfa/activarcodigo", postParams, httpOptions)
          .subscribe((data) => {
            console.info(data);
            if (data.resultado != undefined  && (data.resultado !==false)){
              resolve(true);
            }
            else{
              rejects(false);
            }
          }) ;
      });
    }

    validarMFA(code: string): Promise<boolean> {
      return new Promise((resolve,rejects)=>{
        httpOptions.headers.token=localStorage.getItem("token");
        let postParams =  ({ code: code });

        this.post<MFAValidarResult>("api/mfa/validarcodigo", postParams, httpOptions)
          .subscribe((data) => {
            if (data.resultado != undefined  && (data.resultado !==false)){
              resolve(true);
            }
            else{
              rejects(false);
            }
          }) ;
      }); 
    }

    deleteMFA(): Promise<boolean> {
      return new Promise((resolve,rejects)=>{
        httpOptions.headers.token=localStorage.getItem("token");
        
        this.get<MFAValidarResult>("api/mfa/eliminarmfa", httpOptions)
          .subscribe((data) => {
            if (data.resultado != undefined  && (data.resultado !==false)){
              resolve(true);
            }
            else{
              rejects(false);
            }
          }) ;
      }); 
    }

    ifexistMFA(): Promise<boolean> {
      return new Promise((resolve,rejects)=>{
        httpOptions.headers.token=localStorage.getItem("token");
        this.get<MFAValidarResult>("api/mfa/tienemfa", httpOptions)
          .subscribe((data) => {
            if (data.resultado != undefined  && (data.resultado !==false)){
              resolve(true);
            }
            else{
              rejects(false);
            }
          }) ;
      });
    }

    // ── QR App-Approval 2FA ───────────────────────────────────────────────

    iniciarAprobacion(): Promise<IAprobacionIniciada> {
      return new Promise((resolve, rejects) => {
        httpOptions.headers.token = localStorage.getItem("token");
        // Backend response: { resultado, log, extras: [{ aprobacion_id, token_sesion, expira_en }] }
        this.post<{ resultado: boolean; extras: [IAprobacionIniciada] }>(
          "api/mfa/iniciar_aprobacion", {}, httpOptions
        ).subscribe((data) => {
          if (data.resultado && data.extras && data.extras[0]) {
            resolve(data.extras[0]);
          } else {
            rejects(false);
          }
        });
      });
    }

    estadoAprobacion(aprobacion_id: string | number): Promise<IAprobacionEstado> {
      return new Promise((resolve, rejects) => {
        const opts = { headers: { ...httpOptions.headers, token: localStorage.getItem("token") } };
        // Backend response: { resultado, log, extras: [{ estado }] }
        this.get<{ resultado: boolean; extras: [{ estado: IAprobacionEstado['estado'] }] }>(
          `api/mfa/estado_aprobacion?id=${aprobacion_id}`, opts
        ).subscribe((data) => {
          if (data.resultado && data.extras && data.extras[0]) {
            resolve({ estado: data.extras[0].estado });
          } else {
            // Si resultado=false el backend igual puede devolver extras con estado 'expirado'
            const estado = data?.extras?.[0]?.estado ?? 'expirado';
            resolve({ estado });
          }
        });
      });
    }

    aprobarSesion(aprobacion_id: string | number): Promise<boolean> {
      return new Promise((resolve, rejects) => {
        httpOptions.headers.token = localStorage.getItem("token");
        this.post<MFAValidarResult>("api/mfa/aprobar_sesion", { aprobacion_id }, httpOptions)
          .subscribe((data) => {
            if (data.resultado !== false) {
              resolve(true);
            } else {
              rejects(false);
            }
          });
      });
    }

    rechazarSesion(aprobacion_id: string | number): Promise<boolean> {
      return new Promise((resolve, rejects) => {
        httpOptions.headers.token = localStorage.getItem("token");
        this.post<MFAValidarResult>("api/mfa/rechazar_sesion", { aprobacion_id }, httpOptions)
          .subscribe((data) => {
            if (data.resultado !== false) {
              resolve(true);
            } else {
              rejects(false);
            }
          });
      });
    }
}
